module.exports = __webpack_public_path__ + "static/media/12_naga_dong.85b6efde.png";